module.exports = __webpack_public_path__ + "static/img/logo.ac0712fd.svg";